import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'afs-sweep-slide',
  styleUrl: 'afs-sweep-slide.sass',
  shadow: false,
  scoped: true,
})
export class AfsSweepSlide {

  @Prop() src : string;
  @Prop() alt : string = 'Slide Image';
  @Prop() position : string = 'center';

  render() {
    return (
      <Host class="swiper-slide">
      <img src={this.src} alt={this.alt} style={{
        objectPosition: this.position,
      }}/>
    </Host>
    );
  }

}
